/**
 * MyElsewhere analytics bus. One tiny module isolated from business logic:
 * everything funnels through MEA.track(name, data), which pushes to the GA4
 * dataLayer and mirrors as a DOM event for future pixel adapters (Phase 6).
 * Never carries PII or conversation content — event names and product
 * handles/prices only (PRD §57–58).
 */
(() => {
  'use strict';
  window.dataLayer = window.dataLayer || [];

  const track = (name, data = {}) => {
    try {
      window.dataLayer.push({ event: name, ...data });
      document.dispatchEvent(new CustomEvent('me:analytics', { detail: { name, data } }));
    } catch {
      /* analytics must never break shopping */
    }
  };

  window.MEA = { track };
})();
